// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/:app_group_id/settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdSettings } from "./constants";
import type { GetAppSettingsResponse } from "./types";

export const getAppSettingsApiEndpoint = reactQueryFetcherAdapter(
  appsAppGroupIdSettings,
  (signal: AbortSignal, appGroupId: string, appId?: string): Promise<GetAppSettingsResponse> => {
    if (appId) {
      return fetch(`/apps/${appGroupId}/settings`, "GET", { app_id: appId }, { signal });
    }
    return fetch(`/apps/${appGroupId}/settings`, "GET", {}, { signal });
  }
);
